import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children }) => (
  <p className="text-xs font-mono2 uppercase tracking-[0.25em] text-[#00E676] mb-4">{children}</p>
);

export const SectionTitle = ({ children, className = "" }) => (
  <h2 className={`font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-[1.12] ${className}`}>
    {children}
  </h2>
);

export const Accent = ({ children }) => (
  <em className="not-italic text-[#00E676]">{children}</em>
);
